import React, { useState, useEffect } from 'react';
import useBodyClass from '../../../hooks/useBodyClass';
import { ThirdPartyRegistrationForm } from './registration-form';
import { V360EntityRegistrationStatus } from '../entity-registration/v360-entity-registration-status';
import { CommonService, LocalService } from '../../../core/services';
import { useNavigate, useLocation } from 'react-router-dom';
import { v360organizationDataTypeProps } from 'custom-type';
import * as gtUtil from "../../../core/utility";

const commonService:CommonService = new CommonService();
const localService: LocalService = new LocalService();

export const V360ClientRegistration: React.FC = (props) => {
  const navigate = useNavigate();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const sessionId = queryParams.get('sessionId') || '';

  // interface v360organizationDataTypeProps {
  //   organization_id: string,
  //   organization_name: string,
  //   organization_logo: string
  // }

  const initialV360OrganizationData: v360organizationDataTypeProps = {
    organization_id: 0,
    organization_name: '',
    organization_logo: '',
    entity_type: 'Client',
    isValidSession: false
  }

  const [v360organizationData, setV360OrganizationData] = React.useState<v360organizationDataTypeProps>(initialV360OrganizationData);

  const [showRegistrationStatus, setShowRegistrationStatus] = useState(false);

  // Callback to handle after form submission step.
  const showSubmitStatus = (responseData: {status: boolean, message: string}) => {
    setShowRegistrationStatus(true);
    setV360OrganizationData({...v360organizationData, responseStatus: responseData.status, responseMessage: responseData.message, isValidSession: true});
  };

  useEffect(() => {
    // Fetch live data initially
    commonService.validateV360Organization({sessionId})
      .then((res: any) => {
        if (res.status === gtUtil.Constants.SUCCESS) {
          setShowRegistrationStatus(false);
          setV360OrganizationData({...v360organizationData, ...res.data.rows[0], responseStatus: false, responseMessage: res.info, isValidSession: true});
        } else {
          setShowRegistrationStatus(true);
          setV360OrganizationData({...v360organizationData, responseStatus: false, responseMessage: res.info, isValidSession: false});
          localService.toastify(res.info, 'error', 1000);
          // navigate('/');
        }
    })
      .catch((e: any) => setV360OrganizationData(initialV360OrganizationData));
  }, []);

  return (
    <>
      {
        v360organizationData.organization_id > 0 && v360organizationData.organization_name !== '' && v360organizationData.organization_logo !== '' && !showRegistrationStatus &&

        <ThirdPartyRegistrationForm organization_id={v360organizationData.organization_id} organization_name={v360organizationData.organization_name} organization_logo={v360organizationData.organization_logo} entity_type={v360organizationData.entity_type} showSubmitStatus={showSubmitStatus} />
      }
      {
        showRegistrationStatus &&
        <V360EntityRegistrationStatus organization_id={v360organizationData.organization_id} organization_name={v360organizationData.organization_name} organization_logo={v360organizationData.organization_logo} entity_type={v360organizationData.entity_type} responseStatus={v360organizationData.responseStatus} responseMessage={v360organizationData.responseMessage} isValidSession={v360organizationData.isValidSession} />
      }
    </>
  )
};
